<template>
    <div ref="container" style="width: 52.25rem; height: 52.25rem;"></div>
  </template>
  
  <script setup>
  import { onMounted,  ref } from 'vue';
  import * as THREE from 'three';
  import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
  import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
  
  const container = ref(null);
  // 提升变量作用域
  let scene;
  let camera;
  let renderer;
  let controls;
  
  onMounted(() => {
    // 创建场景
    scene = new THREE.Scene();
  
    // 创建天空盒
    const loader = new THREE.CubeTextureLoader();
    const textureCube = loader.load([
        'right.jpg', // 右侧面纹理
        'left.jpg',  // 左侧面纹理
        'top.jpg',   // 顶面纹理
        'bottom.jpg',// 底面纹理
        'front.jpg', // 正面纹理
        'back.jpg'   // 背面纹理
    ]);
    scene.background = textureCube;
  
    // 创建相机
    camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.z = 1.2;
  
    // 创建渲染器
    renderer = new THREE.WebGLRenderer();
    renderer.setSize(600, 500); 
    container.value.appendChild(renderer.domElement);
  
    // 添加轨道控制器，方便用户交互
    controls = new OrbitControls(camera, renderer.domElement);
  
    // 添加光照
    const ambientLight = new THREE.AmbientLight(0x404040);
    scene.add(ambientLight);
  
    const directionalLight = new THREE.DirectionalLight(0xffffff);
    directionalLight.position.set(1, 1, 1).normalize();
    scene.add(directionalLight);
  
    // 加载 .glb 文件
    const loaderGLTF = new GLTFLoader();
    loaderGLTF.load(
        '/images/3D模型GLB/悬空寺.glb', // 替换为实际的 .glb 文件路径
        (gltf) => {
            scene.add(gltf.scene);
        },
        (xhr) => {
            console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
        },
        (error) => {
            console.error('Error loading GLB file:', error);
        }
    );
  
    // 渲染循环
    const animate = () => {
        requestAnimationFrame(animate);
        controls.update();
        renderer.render(scene, camera);
    };
  
    animate();
  });
  
  
  </script>
  
  <style scoped>
  div {
    margin: 0;
    padding: 0;
  }
  </style>